<template>
    <main>
        <section id="articulos" class="my-3">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="text-center">
                            <h2 class="common-title">Blog</h2>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section id="articulos-grid">
            <div class="container">
                <div class="row">
                    <div v-for="(article, arInx) in articles" :key="arInx" class="col-md-4 col-article-sample">
                        <router-link class="pj-link" :to="'/articles/'+article.id">
                            <div class="box-img">
                              <img class="placed-backg" src="public/images/shared/article.png" v-bind:style="{ backgroundImage: 'url('+article.imgUrl+')' }">
                            </div>
                            <div class="box-info">
                              <h5>{{ article.text }}</h5>
                            </div>
                        </router-link>
                  
                    </div>
                </div>
            </div>
        </section>
    </main>
</template>

<script>
export default {
    data() {
        return {
        articles: [
            { id: 1, imgUrl: 'public/images/pages/blog/image-1.jpg', text: 'Advantages of PVC windows', },
            { id: 1, imgUrl: 'public/images/pages/blog/image-2.jpg', text: 'Advantages of PVC Eslowindows',},
            { id: 1, imgUrl: 'public/images/pages/blog/image-3.jpg', text: 'Tips on how to choose the right PVC',},
            { id: 1, imgUrl: 'public/images/pages/blog/image-3.jpg', text: 'How much do I save with PVC windows?',},
            { id: 1, imgUrl: 'public/images/pages/blog/image-4.jpg', text: 'What benefits do PVC windows bring to the environment?',},
            { id: 1, imgUrl: 'public/images/pages/blog/image-2.jpg', text: 'Tips on how to choose the right PVC',},
        ],
        }
    }
}
</script>